import { PayloadAction } from "@reduxjs/toolkit";
import { createApi, createSlice } from "utils/@reduxjs/toolkit";
import { useInjectReducer } from "utils/redux-injectors";
import { formatErrors, baseQuery, endpoints } from "utils/api/endpoints";
import {
  PaymentHistoryResponse,
  PaymentDetail,
  CustomerDetails,
} from "./types";

export interface PaymentHistoryState {}

export const initialState: PaymentHistoryState = {};

const slice = createSlice({
  name: "paymentHistory",
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: "paymentHistoryApi",
  baseQuery,
  endpoints: (build) => ({
    getPaymentHistory: build.query<
      PaymentHistoryResponse,
      { customerId: string }
    >({
      query: (params) => ({
        ...endpoints.paymentHistory,
        params,
      }),
      transformErrorResponse(baseQueryReturnValue, meta, arg) {
        return formatErrors(baseQueryReturnValue?.data);
      },
    }),
  }),
});

export const { actions: Actions } = slice;

export const usePaymentHistorySlice = () => {
  useInjectReducer({ key: "paymentHistory", reducer: slice.reducer });
  useInjectReducer({ key: "paymentHistoryApi", reducer: api.reducer });
  return { actions: slice.actions, ...api };
};

// Export types for use in components
export type { PaymentDetail, PaymentHistoryResponse, CustomerDetails };
